<template>
  <div id="shioplist">
    <div class="b_banxin" v-for="(item,index) in shopDatas" :key="index">
      <div class="v_listbox">
        <div class="v_listboxtop flex">
          <div class="v_listboxtopleft flex">
            <img :src="http + item.icon_t" alt="" class="v_listboxtopleftico">
            <div class="v_listboxtoplefttxt" >
              {{item.floor_name}}
            </div>
          </div>
          <div class="v_listboxtopright flex txtnowarp">
            <router-link :to="{path:'/brandinner', query:{ id:item1.brand_id}}" target="_blank"  v-if="index1 < 8" class="v_listboxtoprightlink" v-for="(item1,index1) in item.brand" :key="index1">
              {{item1.brand_name}}
            </router-link>
          </div>
          <router-link :to="{path:'/brand', query:{}}" class="v_listboxtoprightlink1">
            查看更多>>
          </router-link>
        </div>
        <div class="v_listboxbtn flex flex_warp">
          <div class="v_listboxbtnbanner">
            <swiper :options="swiperOption">
              <swiper-slide class="swiper-slide" v-for="(item2,index2) in item.guanggao" :key="index2">
                <router-link :to="{path:'/brand', query:{ brand_id:item2.id }}" v-if="item2.url == ''">
                  <img :src="http + item2.banner_img" class="v_bannersize" />
                </router-link>
                <a :href="item2.url" v-else>
                  <img :src="http + item2.banner_img" class="v_bannersize" />
                </a>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination" id="splt"></div>
            </swiper>
          </div>
          <router-link :to="{path:'/details', query:{ goods_id:item3.goods_id }}" target="_blank" class="v_listboxbtnson" v-for="(item3,index3) in item.goods" :key="index3">
            <img :src="http + item3.goods_sku_image" alt="v_listboxbtnsonimg" class="v_listboxbtnsonimg">
            <div class="v_listboxbtnsontxt txtnowarp2">
              {{item3.goods_title}}
            </div>
            <div class="kucunPrice">
              <div class="kucun">库存：{{Number(item3.virtual_inventory) + Number(item3.stock) - Number(item3.virtual_occupy)}}</div>
              <div class="v_listboxbtnsonmoney">
                <span>￥</span> {{item3.price}}
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import qs from "qs";
    export default {
        data() {
            return {
                //广告banner
                swiperOption: {
                    //显示分页
                    pagination: {
                        el: '.swiper-pagination'
                    },
                    //设置点击箭头
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    //自动轮播
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    //开启循环模式
                    loop: true
                },
                //banner数据
                rightbannr: [{
                    bannering: require('@/assets/img/img6.png'),
                    linkid: '1'
                }, {
                    bannering: require('@/assets/img/img5.png'),
                    linkid: '2'
                }],

              shopData:{},
              http:'',//域名拼接
              guanggaoData:[],
              shopDatas:[],//获取到商品数组
            }
        },
      created() {
        let that = this;

        if(that.$storage.get('user_data') != null) {
          that.shopData['userrole'] = that.$storage.get('user_data').rank_id
        } else {
          that.shopData['userrole'] = 1
        }
        that.http = that.$publicUrl.http1;
        that.shangpinFn();

        // that.getFriend();
      },
      methods:{
        shangpinFn() {
          let that = this;

          axios({
            method: 'post',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            url: that.$publicUrl.http1 + that.$publicUrl.homefloor,
            data: qs.stringify(that.shopData),

          })
            .then(function(response) {
              //						console.log(response);
              let data = response.data;
              if(data.stateCode == 10000) {
                let shopDatas = data.data;
                   
                that.guanggaoFn(shopDatas);

              } else {
                // that.personalData = {};
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        },
        guanggaoFn(datas) {
          let that = this;

          axios({
            method: 'post',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            url: that.$publicUrl.http1 + that.$publicUrl.advertiselist,
            data: qs.stringify({userrole:that.shopData.userrole,type:1}),

          })
            .then(function(response) {
              //						console.log(response);
              let data = response.data;
              if(data.stateCode == 10000) {
                let guanggaoData = data.data;
                // console.log(guanggaoData)
               for (let i = 0;i < datas.length;i++){
                 for (let j = 0;j < guanggaoData.length;j++){
                   if (datas[i].floor_id == guanggaoData[j].floor_id){

                     datas[i]['guanggao'] = guanggaoData[j].img;
                   }
                 }
               }
               // console.log(datas)
               that.shopDatas = datas;
               console.log(that.shopDatas)


              } else {
                // that.personalData = {};
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        },
        linkbrandinner(id){

        }
      }
    }
</script>
<style scoped>
    .v_listbox {
        width: 100%;
        height: 565px;
        box-sizing: border-box;
        padding: 0 20px;
        background-color: #ffffff;
        margin-top: 30px;
    }

    .v_listboxtop {
        height: 70px;
        width: 100%;
        border-bottom: 2px solid #dc1e33;
    }

    .v_listboxtopleft {
        width: 235px;
        height: 68px;
        box-sizing: border-box;
        padding: 20px 0;
    }

    .v_listboxtopleftico {
        height: 28px;
        width: 24px;
        display: block;
        object-fit: scale-down;
        margin-right: 10px;
    }

    .v_listboxtoplefttxt {
        width: calc(100% - 38px);
        height: 28px;
        line-height: 28px;
        font-size: 20px;
        overflow: hidden;
    }

    .v_listboxtopright {
        width: 900px;
       overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
        height: 68px;
        box-sizing: border-box;
        padding: 20px 0;
        position: relative;
        /*padding-right: 117.4px;*/
    }

    .v_listboxtoprightlink {
        min-width: 90px;
        display: inline-block;
        padding: 0 15px;
        height: 28px;
        line-height: 28px;
        font-size: 16px;
        cursor: pointer;
    }
    .v_listboxtoprightlink1 {
      min-width: 128px;
      display: inline-block;
      padding: 0 15px;
      height: 70px;
      line-height: 70px;
      font-size: 16px;
      margin-left: 40px;
      cursor: pointer;
    }
    .v_listboxbtnbanner {
        display: inline-block;
        height: 240px;
        width: 385px;
        border-left: 1px solid #eeeeee;
        box-sizing: border-box;
    }

    .v_bannersize {
        height: 240px;
        width: 100%;
        display: block;
        object-fit: scale-down;
        box-sizing: border-box;
    }

    .v_listboxbtnson {
        display: inline-block;
        height: 240px;
        width: 193px;
        border: 1px solid #eeeeee;
        box-sizing: border-box;
    }

    .v_listboxbtnson:hover {
        transition: all 0.2s linear;
        -webkit-box-shadow: 0 1px 6px #dc1e33;
        box-shadow: 0 1px 6px #dc1e33;
        position: relative;
    }

    .v_listboxbtnsonimg {
        height: 140px;
        width: 100%;
        display: block;
        object-fit: scale-down;
    }

    .v_listboxbtnsontxt {
        width: 100%;
        height: 50px;
        line-height: 25px;
        font-size: 16px;
        box-sizing: border-box;
        padding: 0 20px;
    }

    .v_listboxbtnsonmoney {
        /*width: 100%;*/
        font-size: 16px;
        box-sizing: border-box;
        /*padding: 0 20px;*/
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #dc1e33;
    }
    .kucun{
      color: #666666;
      font-size: 14px;
    }
    .kucunPrice{
      display: flex;
      height: 50px;
      line-height: 50px;
      flex-wrap: nowrap;
      justify-content: space-between;
      width: 100%;
      box-sizing: border-box;
      padding:0 20px;
    }
    .v_listboxbtnsonmoney span {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
    }
    .last{
        position: absolute;
        top: 20px;
        right:0;
        /* transform: translateX(-50%) */
    }
</style>
